export default __webpack_public_path__ + "static/media/vector-pagi-1.38709a25.svg";